import { render, staticRenderFns } from "./EditSendExamsTemplateButton.vue?vue&type=template&id=7594e998&"
import script from "./EditSendExamsTemplateButton.vue?vue&type=script&lang=js&"
export * from "./EditSendExamsTemplateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports